import JobSelectTypeFormItem from "./job-select-type-form-item";
import JobSelectStatusFormItem from "./job-select-status-form-item";


const JobFormItems = {
    SelectType: JobSelectTypeFormItem,
    SelectStatus: JobSelectStatusFormItem,
};

export default JobFormItems;